<template>
  
  <div><!-- 封装弹框 -->
  <div style="width:960px;margin-left:15px;margin-top:10px">
               <el-table
              :data="datalist"
              row-key="mem_id"
              default-expand-all
              :tree-props="{children: 'users'}"
              border
              :empty-text="$t('tableText.데이타가없습니다')"
              v-loading="tableLoading"
            >
      <!--   <el-table-column
          type="index"
          width="50" align="center" label="ID">
        </el-table-column> -->
        <el-table-column :label="$t('nav.아이디')" width="100" prop="mem_id" align="center">
          <template slot-scope="scope"><span @click="openIdModel(scope.row.mem_id)" class="text-primary" style="cursor:pointer">{{ scope.row.mem_id}}</span></template>
        </el-table-column>
        <el-table-column :label="$t('tableText.이름')"  prop="mem_name" align="center" width="50">
          <template slot-scope="scope">{{ scope.row.mem_name}}<!--<span class="bg-danger ml-1 text-white px-1 py-1" style="border-radius:5px;" v-if="scope.row.loging == 1">on</span>--></template>
        </el-table-column>

         <el-table-column :label="$t('msg.총판')" prop="" width="50" align="center">
          <template slot-scope="scope">
           <el-button type="text">{{scope.row.ucc}}</el-button>
         </template>
        </el-table-column>

          <template v-if="this.aid!='soft10'">

           <el-table-column :label="$t('msg.카슬머니')" v-if="this.sitetype=='4'" prop="api_money" align="center">
          <template slot-scope="scope">{{ formatMoney(scope.row.api_money)}}</template>
        </el-table-column>
         <el-table-column :label="$t('msg.게임머니')" prop="mem_cash" align="center">
          <template slot-scope="scope">{{ formatMoney(scope.row.mem_cash)}}</template>
        </el-table-column>
        <el-table-column :label="$t('nav.이벤트')" prop="mem_eventmoney" align="center">
          <template slot-scope="scope">{{ formatMoney(scope.row.mem_eventmoney)}}</template>
        </el-table-column>
      
        </template>

        <template v-if="this.aid=='soft10'">

           <el-table-column  :label="$t('msg.카슬머니')" v-if="this.sitetype=='4'" prop="api_money" align="center">
          <template slot-scope="scope">{{ formatMoney(scope.row.api_money)}}</template>
        </el-table-column>
        
        <el-table-column :label="$t('msg.카슬롤링')" prop="mem_eventmoney" align="center">
          <template slot-scope="scope">{{ formatMoney(scope.row.mem_eventmoney)}}</template>
        </el-table-column>

         <el-table-column :label="$t('msg.파워머니')" prop="power_cash" align="center">
          <template slot-scope="scope">{{ formatMoney(scope.row.power_cash)}}</template>
        </el-table-column>
        
        <el-table-column :label="$t('msg.파워롤링')" prop="power_ecash" align="center">
          <template slot-scope="scope">{{ formatMoney(scope.row.power_ecash)}}</template>
        </el-table-column>
      
        </template>

        <el-table-column :label="$t('msg.총입금')" prop="in_money" align="center" width="50">
          <template slot-scope="scope">{{ formatMoney(scope.row.in_money)}} </template>
        </el-table-column>
        <el-table-column :label="$t('msg.총출금')" prop="out_money" align="center">
          <template slot-scope="scope">{{ formatMoney(scope.row.out_money)}}</template>
        </el-table-column>

          <template v-if="sitetype==='4'">
        <el-table-column  
       :label="$t('msg.바카라롤링')" 
       prop="event_loing_recom_e" align="center">
          <template slot-scope="scope">
              {{scope.row.event_loing_recom_e}}%
          </template>
      </el-table-column> 
        <el-table-column  
        :label="$t('msg.슬롯롤링')"  prop="event_loing_recom_slot" align="center">
          <template slot-scope="scope">
              {{scope.row.event_loing_recom_slot}}%
          </template>
      </el-table-column> 

      <el-table-column  
       :label="$t('msg.바카라루징')" prop="pc_e" align="center">
          <template slot-scope="scope">
              {{scope.row.pc_e}}%
          </template>
      </el-table-column> 
        <el-table-column  
        :label="$t('msg.슬롯루징')"
        prop="pc_slot" align="center">
          <template slot-scope="scope">
              {{scope.row.pc_slot}}%
          </template>
      </el-table-column> 
    
      

       </template>

        <el-table-column  :label="$t('msg.가입시간')" prop="mem_regdate" align="center" width="140">
          <template slot-scope="scope">{{ scope.row.mem_regdate}}</template>
        </el-table-column>
      
        
       
      </el-table>
           
</div>

       


  </div>
</template>
<script>
 import layer from './layer.vue';
 import layerNew from '../../components/common/layer-new.vue';
import zpChildDialog from './zp-child-dialog.vue';
  export default{
     components: {
      
      layer,zpChildDialog
    },
    props:{
      info:{
        type:Object,
        default:()=>{
          return {}
        }
      },
      layerid:{
        type:String,
        default:""
      },
    
    
    
    },
  
      data(){
        return{
          datalist:[],
          dataChildlist:[],
          modelFalse:false,
          tableChildLoading:false,
        tableLoading:false,
          ChildVisible:false,
          domain:window.sessionStorage.getItem('domain'),
          sitetype:window.sessionStorage.getItem('sitetype'),
           aid:window.sessionStorage.getItem('admin_id'),
          options: [{
                label: this.$i18n.t("msg.블랙"),
                value: '-2',
               
              }, {
                label: this.$i18n.t("msg.대기"),
                 value: '-1',
                
              }, {
                label: this.$i18n.t("msg.기본"),
                 value: '0',
               
              },{
                label: 'v1',
                 value: '1',
               
              }, {
                label: 'v2',
                 value: '2',
               
              }, {
                label: 'v3',
                 value: '3',
               
              }, {
                label: 'v4',
                 value: '4',
               
              }, {
                label: 'v5',
                 value: '5',
               
              }],
           
          
        }
      },
        created() {
          // this.info.id父组件传给子组件的id值
          this.zpManage(this.info.id);

          
             
    },
      methods:{
         zpManage(id){
          //console.log('id',id)
            this.tableLoading = true
          let token=window.sessionStorage.getItem('user');
                this.$axios({
                  method:'get',
                  url:this.domain+'/admin/memlist_by_bubon?mem_id='+id,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
              this.tableLoading = false
             // console.log('data:===',response.data.data)
              let data = response.data.data
              this.datalist = data
                  
                   
                
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })
      },
          openIdModel(id){

             if(this.aid=='soft10')
           {
                this.$layer.iframe({
                type: 2,
                title: '',
                content: {
                    content: layerNew,
                    parent: this,
                    data:{
                    info:{id:id},
                    layerid:'id'
                    }
                  
                },
                shadeClose: false,
                maxmin:true,
                shade: false,
                area: ['830px', '680px'],
             
             });
              return;
           }
           
           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layer,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
             maxmin : true,

            shade: false,
            area: ['830px', '680px'],
           
        });
        
        },
        Cancel(){
          this.$emit('cancelData')
        },
        openSumzp(id){
          
       this.$layer.iframe({
            type: 2,
            title: this.$i18n.t("title.회원리스트"),
            content: {
                content: zpChildDialog,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
             maxmin : true,

            shade: false,
            area: ['780px', '600px'],
           
        });
     
        

        },
        // Save() {
      //           this.$emit('submitData')
      //       },
      //       handleClose() {
      //           this.$emit('handleClose')
      //       }
      
      }
  }
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/common/bubon-dialog.vue